import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import { articles } from "@/data/articles";

const Articles = () => {
  return (
    <div data-testid="articles-page">
      {/* HERO */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-12 pt-16 pb-12" data-testid="articles-hero">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8 fade-in">
            <div className="eyebrow" data-testid="articles-eyebrow">IV. Publicații</div>
            <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl mt-6 leading-[1.04]" data-testid="articles-title">
              Articole și<br />
              <span className="font-display-italic text-[color:var(--gold)]">studii publicate.</span>
            </h1>
          </div>
          <div className="lg:col-span-4 fade-in delay-2">
            <p className="text-[color:var(--ink-soft)] leading-relaxed">
              Cercetări, studii juridice, comunicări științifice și opinii publicate
              de membrii Asociației General George Pomuț în reviste de specialitate.
            </p>
          </div>
        </div>
      </section>

      <div className="rule max-w-[1280px] mx-auto" />

      {/* LISTA ARTICOLE */}
      <section className="max-w-[1280px] mx-auto px-6 lg:px-12 py-16" data-testid="articles-list">
        {articles.length === 0 ? (
          <p className="text-center text-[color:var(--ink-soft)] font-display-italic text-xl py-16">
            În curând, primele publicații ale asociației.
          </p>
        ) : (
          <div className="space-y-px">
            {articles.map((a) => (
              <Link
                key={a.slug}
                to={`/articole/${a.slug}`}
                className="group grid grid-cols-12 gap-6 py-8 border-b border-[color:var(--ink)]/10 hover:bg-[color:var(--cream)]/40 transition-colors duration-300 px-2"
                data-testid={`article-card-${a.slug}`}
              >
                <div className="col-span-12 sm:col-span-2">
                  <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--ink-soft)]">{a.date}</div>
                </div>
                <div className="col-span-12 sm:col-span-9">
                  <div className="flex items-center gap-2 mb-3">
                    <BookOpen size={14} className="text-[color:var(--gold)]" />
                    <span className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--ink-soft)]">{a.category}</span>
                  </div>
                  <h2 className="font-display text-2xl sm:text-3xl leading-tight text-[color:var(--ink)] group-hover:text-[color:var(--gold)] transition-colors">
                    {a.title}
                  </h2>
                  <div className="mt-2 text-sm text-[color:var(--ink-soft)] font-display-italic">
                    de {a.author} · {a.publishedIn}
                  </div>
                  <p className="mt-4 text-[color:var(--ink-soft)] text-[15px] leading-relaxed max-w-3xl">
                    {a.excerpt}
                  </p>
                </div>
                <div className="col-span-12 sm:col-span-1 flex sm:justify-end items-start sm:items-center">
                  <ArrowUpRight
                    className="text-[color:var(--ink)] group-hover:text-[color:var(--gold)] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all"
                    size={22}
                  />
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Articles;
